import {useDispatch, useSelector} from 'react-redux'
import {
  addSavedFilter,
  selectSaveFilterGroup,
  setCurrentAppliedSavedFilterName,
  selectCurrentAppliedSavedFilterName,
  selectSavedFiltersList,
  setEntireSavedFiltersList,
  updateSavedFilterName,
  deleteSavedFilter,
  selectCurrentFilterCombinationName,
  setCurrentFilterCombinationName,
  selectFilterChangesFromSavedFilter,
  setFilterChangesFromSavedFilter
} from '../slices/savedFilterSlice'

export const useSavedFilter = () => {
  const dispatch = useDispatch()

  const savedFilterGroup = useSelector(selectSaveFilterGroup)
  const appliedSavedFilterName = useSelector(selectCurrentAppliedSavedFilterName)
  const savedFilterList = useSelector(selectSavedFiltersList)
  const currentFilterCombinationName = useSelector(selectCurrentFilterCombinationName)
  const changesFromSavedFilter = useSelector(selectFilterChangesFromSavedFilter)

  return {
    savedFilterGroup,
    appliedSavedFilterName,
    savedFilterList,
    currentFilterCombinationName,
    changesFromSavedFilter,
    addSavedFilter: (value) => dispatch(addSavedFilter(value)),
    setCurrentAppliedSavedFilterName: (value) => dispatch(setCurrentAppliedSavedFilterName(value)),
    setEntireSavedFiltersList: (value) => dispatch(setEntireSavedFiltersList(value)),
    updateSavedFilterName: ({oldName, newName}) => dispatch(updateSavedFilterName({oldName, newName})),
    setCurrentFilterCombinationName: (value) => dispatch(setCurrentFilterCombinationName(value)),
    deleteSavedFilter: (name) => dispatch(deleteSavedFilter(name)),
    setFilterChangesFromSavedFilter: (value) => dispatch(setFilterChangesFromSavedFilter(value))
  }
}
